import { ChainId } from '../chains'
import { Token } from './token'

/**
 * Known WBNB implementation addresses, used in our implementation of Ether#wrapped
 */
export const WBNB: { [chainId: number]: Token } = {
  [ChainId.BSC]: new Token(ChainId.BSC, '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', 18, 'WBNB', 'Wrapped BNB'),
  [ChainId.OPBNB]: new Token(ChainId.OPBNB, '0x4200000000000000000000000000000000000006', 18, 'WBNB', 'Wrapped BNB')
}
